export default "__VITE_ASSET__C3BA62Ot__"